import { slicedToArray as _slicedToArray, extends as _extends, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import { styled, Menu } from '@mui/material';
import classnames from '../../../node_modules/classnames/index.js';
import React, { useState, useRef, useCallback } from 'react';

var TriggerMenuTrigger = function TriggerMenuTrigger(props) {
  return /*#__PURE__*/React.createElement("div", props);
};

var TriggerMenuBase = function TriggerMenuBase(_ref) {
  var _ref$triggerComponent = _ref.triggerComponent,
      TriggerComponent = _ref$triggerComponent === void 0 ? TriggerMenuTrigger : _ref$triggerComponent,
      triggerProps = _ref.triggerProps,
      children = _ref.children,
      direction = _ref.direction,
      _ref$openOnHover = _ref.openOnHover,
      openOnHover = _ref$openOnHover === void 0 ? false : _ref$openOnHover,
      _ref$hoverCloseDelay = _ref.hoverCloseDelay,
      hoverCloseDelay = _ref$hoverCloseDelay === void 0 ? 0 : _ref$hoverCloseDelay,
      _ref$allowClickPropag = _ref.allowClickPropagation,
      allowClickPropagation = _ref$allowClickPropag === void 0 ? false : _ref$allowClickPropag,
      _ref$allowFocusPropag = _ref.allowFocusPropagation,
      allowFocusPropagation = _ref$allowFocusPropag === void 0 ? false : _ref$allowFocusPropag,
      _ref$MenuProps = _ref.MenuProps,
      MenuProps = _ref$MenuProps === void 0 ? {} : _ref$MenuProps,
      className = _ref.className;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var mouseOver = useRef(false);
  var leaveTimeout = useRef(null);
  var open = !!anchorEl;
  var triggerOnClick = useCallback(function (e) {
    setAnchorEl(e === null || e === void 0 ? void 0 : e.currentTarget);
  }, []);
  var triggerOnMouseEnter = useCallback(function (e) {
    mouseOver.current = true;

    if (leaveTimeout.current) {
      clearTimeout(leaveTimeout.current);
      leaveTimeout.current = null;
    }

    setAnchorEl(e === null || e === void 0 ? void 0 : e.currentTarget);
  }, []);
  var onMouseLeave = useCallback(function () {
    mouseOver.current = false;

    if (leaveTimeout.current) {
      clearTimeout(leaveTimeout.current);
    }

    if (hoverCloseDelay <= 0) {
      setAnchorEl(null);
      return;
    }

    leaveTimeout.current = setTimeout(function () {
      if (!mouseOver.current) {
        setAnchorEl(null);
      }
    }, hoverCloseDelay);
  }, [hoverCloseDelay]);
  var onStopPropagation = useCallback(function (e) {
    e.stopPropagation();
    e.preventDefault(); // also allows menu to be safely nested within an a tag
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(className, {
      open: open
    }),
    onMouseLeave: openOnHover ? onMouseLeave : undefined,
    onClick: allowClickPropagation ? undefined : onStopPropagation,
    onMouseDown: allowClickPropagation ? undefined : onStopPropagation,
    onMouseUp: allowClickPropagation ? undefined : onStopPropagation,
    onFocus: allowFocusPropagation ? undefined : onStopPropagation,
    onBlur: allowFocusPropagation ? undefined : onStopPropagation
  }, /*#__PURE__*/React.createElement(TriggerComponent, _extends({}, triggerProps, {
    onClick: triggerOnClick,
    onMouseEnter: openOnHover ? triggerOnMouseEnter : undefined
  })), /*#__PURE__*/React.createElement(Menu, _extends({
    transformOrigin: {
      horizontal: direction === "left" ? "right" : "left",
      vertical: "top"
    },
    anchorOrigin: {
      horizontal: direction === "left" ? "right" : "left",
      vertical: "bottom"
    },
    autoFocus: false,
    disableAutoFocus: true // prevent aria-hidden focus warnings

  }, MenuProps, {
    anchorEl: anchorEl,
    open: open,
    keepMounted: true // ensures that modal menu items stay open
    ,
    hideBackdrop: true,
    MenuListProps: _objectSpread2(_objectSpread2({}, MenuProps.MenuListProps), {}, {
      onKeyDown: function onKeyDown(e) {
        if (!open) return; // override default tab interception which blocks modal tabbing

        if (e.key === "Tab") {
          setAnchorEl(null);
          if (MenuProps.onClose) MenuProps.onClose(e, "tabKeyDown");
        }
      }
    }),
    onClose: function onClose(e, reason) {
      if (!open) return;
      setAnchorEl(null);
      if (MenuProps.onClose) MenuProps.onClose(e, reason);
    },
    onClick: function onClick(e) {
      if (!open) return;
      setAnchorEl(null);
      if (MenuProps.onClick) MenuProps.onClick(e);
    },
    sx: openOnHover ? function (theme) {
      var _MuiPaperRoot;

      var sx = typeof MenuProps.sx === "function" ? MenuProps.sx(theme) : MenuProps.sx;
      return _objectSpread2(_objectSpread2({
        pointerEvents: "none"
      }, sx), {}, {
        "> .MuiPaper-root": _objectSpread2({
          pointerEvents: "auto"
        }, (_MuiPaperRoot = sx === null || sx === void 0 ? void 0 : sx["> .MuiPaper-root"]) !== null && _MuiPaperRoot !== void 0 ? _MuiPaperRoot : {})
      });
    } : MenuProps.sx
  }), children));
};

TriggerMenuBase.propTypes = {
  children: propTypes.node,
  triggerComponent: propTypes.elementType,
  triggerProps: propTypes.any,
  direction: propTypes.oneOf(["left", "right"]),
  openOnHover: propTypes.bool,
  hoverCloseDelay: propTypes.number,
  allowClickPropagation: propTypes.bool,
  allowFocusPropagation: propTypes.bool,
  MenuProps: propTypes.any,
  className: propTypes.string,
  sx: propTypes.any,
  variant: propTypes.any
};
var TriggerMenuRoot = styled(TriggerMenuBase)(function (_ref2) {
  _ref2.openOnHover;
  return {
    display: "inline-block"
  };
});

var TriggerMenu = function TriggerMenu(props) {
  return /*#__PURE__*/React.createElement(TriggerMenuRoot, props);
};

var TriggerMenu$1 = TriggerMenu;

export { TriggerMenu$1 as default };
